<script lang="ts">
  import { customCategorySorting, EMOTES } from '@pin/emotes/custom';
  import type { Emote } from '@pin/schemas/emotes';

  interface Props {
    onpick: (emote: Emote) => void;
  }
  let { onpick }: Props = $props();

  const baseUrl = import.meta.env.VITE_EMOTES_BASE_URL ?? '/';

  // In the client's picker, an emote without a category is under
  // 'Egendefinert'
  const categoryOf = (emote: Emote) => emote.category ?? 'Egendefinert';
  const categories = [...new Set(EMOTES.map(categoryOf))]
    .sort(customCategorySorting)
    .map((category) => ({
      category,
      emotes: EMOTES.filter((emote) => categoryOf(emote) === category),
    }));
</script>

<div role="group" aria-label="Emotes">
  {#each categories as { category, emotes } (category)}
    <p class="category">{category}</p>
    <div class="emotes">
      {#each emotes as emote (emote.name)}
        <button
          type="button"
          title={emote.shortcodes[0]}
          aria-label={emote.name}
          onmousedown={(e) => {
            // Keep the caret in the field
            e.preventDefault();
          }}
          onclick={() => onpick(emote)}
        >
          <img
            src={baseUrl + emote.url}
            alt=""
            width={emote.width}
            height={emote.height}
            loading="lazy"
            decoding="async"
          />
        </button>
      {/each}
    </div>
  {/each}
</div>

<style>
  .category {
    margin: 0.25rem 0;
    color: var(--color-zinc-400);
    font-size: 0.75rem;
  }

  .category:not(:first-child) {
    margin-top: 0.75rem;
  }

  .emotes {
    display: flex;
    flex-wrap: wrap;
    gap: 0.25rem;
  }

  .emotes button {
    all: unset;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.75rem;
    height: 2.75rem;
    border-radius: 0.25rem;
    cursor: pointer;
  }

  .emotes button:hover,
  .emotes button:focus-visible {
    background-color: var(--color-zinc-600);
  }

  .emotes img {
    max-width: 2.25rem;
    max-height: 2.25rem;
    width: auto;
    height: auto;
  }
</style>
